import VueCircle from "vue2-circle-progress";
import axios from "axios";
import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config";

export default {
  props: {
    files: Array,
    uploadUrl: String, //make quicktransfer or uploadfiles
    doneFunc: {
      type: Function,
      default: () => {},
    },
  },
  components: { VueCircle },
  data() {
    return {
      id: this.$options.name,
      uploadPercentage: 0,
      cancelTokenSource: false,
    };
  },
  created() {
    this.cancelTokenSource = axios.CancelToken.source();

    EventBus.$on(`${this.id}-cancel`, () => {
      //cancel upload
      this.cancelTokenSource.cancel("Upload cancelled");
    });

    this.uploadFiles();
  },
  methods: {
    uploadFiles() {
      const formData = new FormData();

      if (this.$store.state.uploadFolderInfo.name) {
        formData.append("folder", this.$store.state.uploadFolderInfo.id);
        formData.append("myspace", this.$store.state.uploadFolderInfo.mySpace);
      }

      if (this.files) {
        this.files.forEach((file, index) => {
          formData.append(`files[${index}]`, file);
        });

        this.$axios
          .post(`${baseUrl}/${this.uploadUrl}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              this.uploadPercentage = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );
              this.$refs.completedCircle.updateProgress(this.uploadPercentage);

              if (this.uploadPercentage >= 100) {
                //this.uploadComplete = true;
              }
            },
            cancelToken: this.cancelTokenSource.token,
          })
          .then((r) => {
            this.doneFunc();
          })
          .catch((e) => {
            this.doneFunc();
          });
      }
    },
  },
};
